import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { GiftBoxType } from '@models/gift';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useGiftBoxes(type: GiftBoxType, sorter: string) {
  const { data, status } = useQuery(queries.giftBox.list(type, sorter));
  const { pop } = useFlow();
  const toast = useToast();
  useEffect(() => {
    if (status === 'error') {
      toast.error('선물함을 불러오는데 실패했습니다.');
      pop();
    }
  }, [status, pop, toast]);
  return data?.content;
}

export default useGiftBoxes;
